import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CookiePreferencesService } from 'src/app/core/services/cookie-preferences.service';

@Component({
  selector: 'aig-option-selection',
  imports: [],
  templateUrl: './option-selection.component.html',
  styleUrl: './option-selection.component.scss',
})
export class OptionSelectionComponent implements OnInit {
  public switchActivatedStatistics: boolean = false;
  public switchActivatedMarketing: boolean = false;

  constructor(private cookiePreferencesService: CookiePreferencesService) {}

  ngOnInit(): void {
    const preferences = this.cookiePreferencesService.getPreferences();
    if (preferences) {
      this.switchActivatedStatistics = preferences.analytics;
      this.switchActivatedMarketing = preferences.marketing;
    }
  }

  toggleSwitchStadistics(): void {
    this.switchActivatedStatistics = !this.switchActivatedStatistics;
    this.savePreferences();
  }

  toggleSwitchMarketing(): void {
    this.switchActivatedMarketing = !this.switchActivatedMarketing;
    this.savePreferences();
  }
  private savePreferences(): void {
    this.cookiePreferencesService.savePreferences({
      functional: true, // Siempre activadas
      marketing: this.switchActivatedMarketing,
      analytics: this.switchActivatedStatistics
    });
  }
}
